<template>
    <div>
        <el-row class="row table-title">
            <el-col :span="24" class="text-left">回款计划</el-col>
        </el-row>
        <el-row class="row">
            <el-col :span="12" class="text-left">整体达成进度：{{oneInfo.totalAchieveProgress}}%</el-col>
            <el-col :span="12" class="text-right">
                <el-button v-if="canManagePlans" type="text" @click="addPlan">新增</el-button>
            </el-col>
        </el-row>
        <el-table v-loading="loadingOne" :data="oneData">
            <el-table-column label="期数" align="center" prop="planFundBatch"/>
            <el-table-column label="款项名称" min-width="90" align="center" prop="paymentName" />
            <el-table-column label="款项比例" min-width="100" align="center">
                <template slot-scope="scope">
                <span>{{ scope.row.paymentRatio }}%</span>
                </template>
            </el-table-column>
            <el-table-column label="计划回款日期" min-width="110" align="center" prop="planFundDate" />
            <el-table-column label="计划回款金额（元）" min-width="130" align="center">
                <template slot-scope="scope">
                    <span>{{ amountFormat(scope.row.planFundAmount) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="实际回款金额（元）" min-width="130" align="center">
                <template slot-scope="scope">
                    <span>{{ amountFormat(scope.row.actualAmount) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="达成进度" min-width="100" align="center" prop="achieveProgress">
                <template slot-scope="scope">
                <span>{{ scope.row.achieveProgress }}%</span>
                </template>
            </el-table-column>
            <el-table-column label="备注" min-width="130" :show-overflow-tooltip="true" prop="remark" />
            <el-table-column label="操作" width="100" fixed="right" :show-overflow-tooltip="true" align="center" >
                <template slot-scope="scope">
                    <el-button v-if="canManagePlans" type="text" @click="handlePlan(scope.row, 'edit')">编辑</el-button>
                    <el-button v-if="canManagePlans" type="text" @click="handlePlan(scope.row, 'del')">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-row v-if="canReadRecords" class="row table-title">
            <el-col :span="24" class="text-left">回款记录</el-col>
        </el-row>
        <el-row v-if="canReadRecords" class="row">
            <el-col :span="12" class="text-left">回款总额：{{totalAmount}}元</el-col>
            <el-col :span="12" class="text-right">
                <el-button type="text" @click="addRecord" v-hasPermi="['crm:fundRecord:add']">新增</el-button>
            </el-col>
        </el-row>
        <el-table v-if="canReadRecords" v-loading="loadingTwo" :data="twoData">
            <el-table-column label="回款日期" min-width="110" align="center" prop="actualFundDate" />
            <el-table-column label="回款金额（元）" min-width="100" align="center" prop="actualFundAmount" />
            <el-table-column label="支付方式" min-width="100" align="center" prop="payTypeDesc" />
            <el-table-column label="回款银行" min-width="100" align="center" prop="bankDesc" />
            <el-table-column label="回款部门" min-width="110" align="center" prop="fundDeptName" />
            <el-table-column label="回款人" min-width="100" align="center" prop="fundUserName" />
            <el-table-column label="备注" min-width="130" :show-overflow-tooltip="true" prop="remark" />
            <el-table-column label="操作" width="100" fixed="right" :show-overflow-tooltip="true" align="center" >
                <template slot-scope="scope">
                    <el-button type="text" v-hasPermi="['crm:fundRecord:edit']" @click="handleRocord(scope.row, 'edit')">编辑</el-button>
                    <el-button type="text" v-hasPermi="['crm:fundRecord:delete']" @click="handleRocord(scope.row, 'del')">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-dialog :title="(kind == 'add' ? '新增' : '编辑') + '回款计划'" :visible.sync="visible" :close-on-click-modal="false" :close-on-press-escape="false" width="600px">
            <el-form :model="newObj" :rules="rules" ref="addForm" label-width="150px">
                <el-row v-if="kind == 'add'">
                    <el-form-item label="合同编号:">
                        {{detailInfo.contractNum}}
                    </el-form-item>
                    <el-form-item label="商机:">
                        {{detailInfo.businessName}}
                    </el-form-item>
                    <el-form-item label="签约客户:">
                        {{detailInfo.customerName}}
                    </el-form-item>
                    <el-form-item label="总金额（元）:">
                        {{amountFormat(detailInfo.contractAmount)}}
                    </el-form-item>
                </el-row>
                <el-row v-else>
                    <el-form-item label="计划期数:">
                        第 {{newObj.planFundBatch}} 期
                    </el-form-item>
                </el-row>
                <el-form-item label="款项名称:" prop="paymentName">
                    <el-select v-model="newObj.paymentName" style="width: 200px" filterable allow-create clearable  placeholder="请选择款项名称">
                        <el-option v-for="dict in paymentOptions" :key="dict.dictLabel" :label="dict.dictLabel" :value="dict.dictValue"/>
                    </el-select>
                </el-form-item>
                <el-form-item label="款项比例:" prop="paymentRatio">
                    <el-input v-model="newObj.paymentRatio" style="width: 200px" type="number" :maxlength="30" placeholder="请输入款项比例" clearable/>
                    <span> %</span>
                </el-form-item>
                <el-form-item label="计划回款日期:" prop="planFundDate">
                    <el-date-picker v-model="newObj.planFundDate" style="width: 200px" value-format="yyyy-MM-dd" type="date" range-separator="-" placeholder="请选择日期"/>
                </el-form-item>
                <el-form-item label="计划回款（元）:">
                    {{amountFormat(newObj.paymentRatio * detailInfo.contractAmount / 100)}}
                </el-form-item>
                <el-form-item label="备注:" prop="remark">
                    <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 5}" :maxlength="500" show-word-limit v-model="newObj.remark" placeholder="请输入500字以内" clearable/>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="clearForm('plan')">取消</el-button>
                <el-button type="primary" @click="confirmInfo('plan')">确认</el-button>
            </span>
        </el-dialog>
        <el-dialog :title="(kind == 'add' ? '新增' : '编辑') + '回款记录'" :visible.sync="recordVisible" :close-on-click-modal="false" :close-on-press-escape="false" width="600px">
            <el-form :model="newRecordObj" :rules="recordRules" ref="addRecordForm" label-width="150px">
                <el-row v-if="kind == 'add'">
                    <el-form-item label="合同编号:">
                        {{detailInfo.contractNum}}
                    </el-form-item>
                    <el-form-item label="商机:">
                        {{detailInfo.businessName}}
                    </el-form-item>
                    <el-form-item label="签约客户:">
                        {{detailInfo.customerName}}
                    </el-form-item>
                    <el-form-item label="总金额（元）:">
                        {{detailInfo.contractAmount}}
                    </el-form-item>
                    <el-form-item label="已回款（元）:">
                        {{amountFormat(detailInfo.fundedAmount)}}
                    </el-form-item>
                </el-row>
                <el-form-item label="回款日期:" prop="actualFundDate">
                    <el-date-picker v-model="newRecordObj.actualFundDate" style="width: 200px" value-format="yyyy-MM-dd" type="date" range-separator="-" placeholder="请选择日期"/>
                </el-form-item>
                <el-form-item label="回款金额（元）:" prop="actualFundAmount">
                    <el-input v-model="newRecordObj.actualFundAmount" style="width: 200px" type="number" :maxlength="30" placeholder="请输入回款金额" clearable/>
                </el-form-item>
                <fund-owner-select ref="fundOwnerSelectRef" :form-param="newRecordObj"/>
                <el-form-item label="支付方式:" prop="payType">
                    <el-select v-model="newRecordObj.payType" style="width: 200px" filterable placeholder="请选择支付方式">
                        <el-option v-for="dict in payTypeOptions" :key="dict.dictValue" :label="dict.dictLabel" :value="dict.dictValue"/>
                    </el-select>
                </el-form-item>
                <el-form-item label="回款银行:" prop="bank">
                    <el-select v-model="newRecordObj.bank" style="width: 200px" filterable placeholder="请选择回款银行">
                        <el-option v-for="dict in bankOptions" :key="dict.dictValue" :label="dict.dictLabel" :value="dict.dictValue"/>
                    </el-select>
                </el-form-item>
                <el-form-item label="备注:" prop="remark">
                    <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 5}" :maxlength="500" show-word-limit v-model="newRecordObj.remark" placeholder="请输入500字以内" clearable/>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="clearForm('record')">取消</el-button>
                <el-button type="primary" @click="confirmInfo('record')">确认</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { queryContractPlanFundInfo, createContractPlanFund, updateContractPlanFund, delContractPlanFund} from "@/api/crm/planFund";
import { queryContractFundRecordInfo, createContractFundRecord, updateContractFundRecord, delContractFundRecord } from "@/api/crm/fundRecord";
import { queryContractDetail } from "@/api/crm/contract";
import { amountFormat } from '@/utils/index'
import FundOwnerSelect from "@/views/crm/fundRecord/fundOwnerSelect";
import { checkPermi } from '@/utils/permission'

export default {
    name: "contractDetailInfo",
    props: {
        contractId: {},
        height: {
            type: String,
            default () {
                return "250"
            }
        }
    },
    data() {
        return {
            kind: 'add',
            amountFormat,
            oneData: [],
            paymentOptions: [], // 款项名称
            bankOptions: [], // 回款银行
            payTypeOptions: [], // 支付方式
            oneInfo: {
              totalAchieveProgress: 0
            },
            twoData: [],
            loadingOne: false,
            loadingTwo: false,
            totalAmount: 0,
            visible: false,
            recordVisible: false,
            detailInfo: {},
            newObj: {
                paymentName: null,
                paymentRatio: null,
                planFundDate: null,
                remark: ''
            },
            newRecordObj: {
                actualFundDate: null,
                actualFundAmount: null,
                fundDeptId: null,
                fundUserId: null,
                payType: null,
                bank: null,
                remark: ''
            },
            rules: {
                paymentName: [
                    {required: true, message: '请选择款项名称', trigger: 'change'}
                ],
                paymentRatio: [
                    {required: true, message: '请输入款项比例', trigger: 'change'}
                ],
                planFundDate: [
                    {required: true, message: '请选择计划回款日期', trigger: 'change'}
                ]
            },
            recordRules: {
                payType: [
                    {required: true, message: '请选择支付方式', trigger: 'change'}
                ],
                bank: [
                    {required: true, message: '请选择回款银行', trigger: 'change'}
                ],
                actualFundAmount: [
                    {required: true, message: '请输入回款金额', trigger: 'blur'}
                ],
                actualFundDate: [
                    {required: true, message: '请输入回款日期', trigger: 'change'}
                ],
                fundDeptId: [
                    {required: true, message: '请选择回款部门', trigger: 'change'}
                ],
                fundUserId: [
                    {required: true, message: '请选择回款人', trigger: 'change'}
                ]
            },
        };
    },
    computed: {
        canManagePlans () {
            return String(this.$store.getters.tenantId) !== '118' || checkPermi(['crm:planFund:manage'])
        },
        canReadRecords () {
            return String(this.$store.getters.tenantId) !== '118' || checkPermi(['crm:fundRecord:manage', 'crm:fundRecord:detail', 'crm:fundRecord:edit', 'crm:fundRecord:delete'])
        }
    },
    created() {
        if (this.contractId) {
            this.queryList();
        }
        this.queryDetail()
        this.getDicts("payment_name").then(response => {
            this.paymentOptions = response.data;
        });
        this.getDicts("bank").then(response => {
            this.bankOptions = response.data;
        });
        this.getDicts("pay_type").then(response => {
            this.payTypeOptions = response.data;
        });
    },
    components: {
        FundOwnerSelect
    },
    watch: {
        contractId (val) {
            if (val) {
                this.queryList();
            } else {
                this.oneData = []
                this.oneInfo = {
                  totalAchieveProgress: 0
                }
                this.twoData = []
                this.totalAmount = 0
            }
        }
    },
    methods: {
        // 处理回款计划
        handlePlan (row, type) {
            if (type == 'edit') {
                this.kind = 'edit'
                this.newObj = JSON.parse(JSON.stringify(row))
                this.visible = true
            } else {
                this.$confirm('删除后将无法恢复，是否确认删除该计划?', "警告", {
                    confirmButtonText: "确认",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    const loading = this.$loading({
                        lock: true,
                        text: '加载中',
                        spinner: 'el-icon-loading'
                    });
                    delContractPlanFund({
                        id: row.planId
                    }).then(response => {
                        this.$message.success('计划删除成功')
                        this.getTableOne()
                        this.$emit('success')
                        loading.close();
                    }).catch(error => {
                        loading.close();
                    });

                })
            }
        },
        // 处理回款记录
        handleRocord (row, type) {
            if (type == 'edit') {
                this.kind = 'edit'
                this.newRecordObj = JSON.parse(JSON.stringify(row))
                this.recordVisible = true
                this.$nextTick(() => {
                    this.$refs.fundOwnerSelectRef.setSelection(row.fundDeptId, row.fundUserId)
                })
            } else {
                this.$confirm('删除后将无法恢复，是否确认删除该记录?', "警告", {
                    confirmButtonText: "确认",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    const loading = this.$loading({lock: true, text: '加载中', spinner: 'el-icon-loading'});
                    delContractFundRecord({
                        id: row.recordId
                    }).then(response => {
                        this.$message.success('记录删除成功')
                        this.queryList()
                        this.$emit('success')
                    }).finally(() => {
                      loading.close();
                    });
                })
            }
        },
        // 新增计划
        addPlan () {
            this.visible = true
            this.newObj.planFundBatch = this.oneData.length + 1
        },
        // 新增记录
        addRecord () {
            this.kind = 'add'
            this.newRecordObj = {
                actualFundDate: null,
                actualFundAmount: null,
                fundDeptId: this.detailInfo.assignDeptId || null,
                fundUserId: this.detailInfo.assignUserId || null,
                payType: null,
                bank: null,
                remark: ''
            }
            this.recordVisible = true
            this.$nextTick(() => {
                this.$refs.fundOwnerSelectRef.setSelection(
                    this.detailInfo.assignDeptId,
                    this.detailInfo.assignUserId
                )
            })
        },
        // 查询列表数据
        queryList () {
            this.getTableOne()
            this.getTableTwo()
        },
        // 获取表格1的数据
        getTableOne () {
            this.loadingOne = true;
          queryContractPlanFundInfo({
                id: this.contractId
            }).then(response => {
                this.oneData = response.data.planFundList || [];
                this.oneInfo.totalAchieveProgress = response.data.totalAchieveProgress
                this.loadingOne = false;
            }).catch(error => {
                this.loadingOne = false;
            });
        },
        // 获取表格2的数据
        getTableTwo () {
            if (!this.canReadRecords) {
                this.twoData = []
                this.totalAmount = 0
                this.loadingTwo = false
                return
            }
            this.loadingTwo = true;
            queryContractFundRecordInfo({
                id: this.contractId
            }).then(response => {
                this.twoData = response.data.fundRecordList || [];
                this.totalAmount = response.data.totalFundAmount || 0
                this.loadingTwo = false;
            }).catch(error => {
                this.loadingTwo = false;
            });
        },
        // 查询合同详情
        queryDetail () {
            queryContractDetail({
                id:this.contractId
            }).then(response => {
                this.detailInfo = response.data
            }).catch(error => {
                this.detailInfo = {}
            })
        },
        switchPlan () {
            if (this.kind == 'add') {
                return createContractPlanFund(Object.assign(
                            this.newObj,
                            {
                               contractId: this.contractId
                            }
                        ))
            } else {
                return updateContractPlanFund(Object.assign(
                            this.newObj,
                            {
                               contractId: this.contractId,
                               planId: this.newObj.planId
                            }
                        ))
            }
        },
        switchRecord () {
            if (this.kind == 'add') {
                return createContractFundRecord(Object.assign(
                            this.newRecordObj,
                            {
                               contractId: this.contractId
                            }
                        ))
            } else {
                return updateContractFundRecord(Object.assign(
                            this.newRecordObj,
                            {
                               contractId: this.contractId,
                               recordId: this.newRecordObj.recordId
                            }
                        ))
            }
        },
        // 提交
        confirmInfo (type) {
            let kindStr = ''
            if (this.kind == 'add') {
                kindStr = '新增'
            } else if (this.kind == 'edit') {
                kindStr = '编辑'
            }
            if (type == 'plan') {
                this.$refs['addForm'].validate((valid) => {
                    if (valid) {
                        const loading = this.$loading({
                            lock: true,
                            text: '加载中',
                            spinner: 'el-icon-loading'
                        });

                        this.switchPlan().then(response => {
                            const {code, msg} = response
                            loading.close();
                            if (code == 200) {
                                this.visible = false
                                this.getTableOne()
                                this.clearForm(type)
                                this.$emit('success')
                                this.msgSuccess(`回款计划${kindStr}成功`);
                            } else {
                                this.msgWarning(msg || `回款计划${kindStr}失败`)
                            }
                        }).catch(error => {
                            loading.close()
                        })
                    }
                });
            } else {
                this.$refs['addRecordForm'].validate((valid) => {
                    if (valid) {
                        const loading = this.$loading({
                            lock: true,
                            text: '加载中',
                            spinner: 'el-icon-loading'
                        });
                        this.switchRecord().then(response => {
                            const {code, msg} = response
                            loading.close();
                            if (code == 200) {
                                this.recordVisible = false
                                this.queryList()
                                this.clearForm(type)
                                this.$emit('success')
                                this.msgSuccess(`回款记录${kindStr}成功`);
                            } else {
                                this.msgWarning(msg || `回款记录${kindStr}失败`)
                            }
                        }).catch(error => {
                            loading.close()
                        })
                    }
                });
            }
        },
        // 清空表格
        clearForm (type) {
            if (type == 'plan') {
                this.resetForm("addForm");
                this.visible = false
            } else {
                this.resetForm("addRecordForm")
                this.recordVisible = false
            }
            this.kind = 'add'
            this.queryDetail()
        }
    }
};
</script>
<style lang="scss" scoped>
    .card-item {
      padding: 20px;
      border: 1px solid #d9d9d9;
      border-radius: 6px;
    }
    .text-left,
    .text-right {
        .goDetail {
            color: #409eff;
        }
    }
    .text-right {
        text-align: right;
    }
    .table-title {
        margin: 15px 0;
        .text-left {
            padding-left: 10px;
            border-left: 5px solid #409eff;
        }
    }
</style>
